import { Outlet } from 'react-router-dom'
import { DashboardLayout } from '@/components/layout/dashboardLayout'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { AlertCircle } from 'lucide-react'

const ErrorBoundary = () => {
  return (
    <DashboardLayout>
      <div>
        <Alert variant="destructive" className="max-w-xl">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Oops! Something went wrong.</AlertTitle>
          <AlertDescription>Please try again later or refresh the page. If the problem persists, contact support.</AlertDescription>
        </Alert>
      </div>
    </DashboardLayout>
  )
}

const AppRoot = () => {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  )
}

export { ErrorBoundary }
export default AppRoot
